
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(2(18[08]|33|821)|1(00|545|889)|9(324|391|807)|353|4896|5154|6803|7489|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
